/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import type {
  ApiErrorDTO,
  BadRequestResponse,
  DeleteSuccessDTO,
  EmailSuccessDTO,
  ForbiddenResponse,
  GetCatalogDownloadHistoryParams,
  GetStatistics200,
  GetUsersParams,
  InternalServerErrorResponse,
  PaginatedCatalogDownloadHistoryItemsDTO,
  PaginatedUserListItemsDTO,
  UnauthorizedResponse,
  UserCreateDTO,
  UserDTO,
  UserTransferSuccessDTO,
  UserUpdateDTO,
} from "../../model";
import { customFetchInstance } from "../../../custom-fetch-instance";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Returns all users matching the filter criteria. All given filter will be combined as AND criteria
 * @summary Returns a paginated List of all users
 */
export type getUsersResponse = {
  data: PaginatedUserListItemsDTO;
  status: number;
};

export const getGetUsersUrl = (params?: GetUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `http://localhost:8080/platform/v1/users?${normalizedParams.toString()}`
    : `http://localhost:8080/platform/v1/users`;
};

export const getUsers = async (
  params?: GetUsersParams,
  options?: RequestInit
): Promise<getUsersResponse> => {
  return customFetchInstance<Promise<getUsersResponse>>(
    getGetUsersUrl(params),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetUsersQueryKey = (params?: GetUsersParams) => {
  return [
    `http://localhost:8080/platform/v1/users`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({
    signal,
  }) => getUsers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUsers>>
>;
export type GetUsersQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params: undefined | GetUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a paginated List of all users
 */

export function useGetUsers<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetUsersSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({
    signal,
  }) => getUsers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUsersSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUsers>>
>;
export type GetUsersSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetUsersSuspense<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params: undefined | GetUsersParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetUsersSuspense<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetUsersSuspense<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a paginated List of all users
 */

export function useGetUsersSuspense<
  TData = Awaited<ReturnType<typeof getUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  params?: GetUsersParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUsersSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new User. Can throw the following error codes:

`ERR_USERS_TYPE_REQUIRED`, `ERR_USERS_INVALID_EMAIL`, `ERR_USERS_INVALID_USERNAME, 
`ERR_USERS_USERNAME_TAKEN,`ERR_USERS_INVALID_ORGANISATION_CODE`,
`ERR_USERS_INVALID_ORGANISATION_NAME` and `ERR_USERS_NO_ORGANISATION_NAME`.

The username will be validated against the following regex expression in both, frontend and backend: `^(?=.{4,30}$)[\p{L}\p{N}@._-]+$`
If the username violates against this regex, the error code `ERR_USERS_INVALID_USERNAME` will be thrown.

Further explanation about the error codes can be found in the projects README.

 * @summary Creates a new user
 */
export type createUserResponse = {
  data: UserDTO;
  status: number;
};

export const getCreateUserUrl = () => {
  return `http://localhost:8080/platform/v1/users`;
};

export const createUser = async (
  userCreateDTO: UserCreateDTO,
  options?: RequestInit
): Promise<createUserResponse> => {
  return customFetchInstance<Promise<createUserResponse>>(getCreateUserUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(userCreateDTO),
  });
};

export const getCreateUserMutationOptions = <
  TError =
    | ApiErrorDTO
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUser>>,
    TError,
    { data: UserCreateDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  { data: UserCreateDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUser>>,
    { data: UserCreateDTO }
  > = (props) => {
    const { data } = props ?? {};

    return createUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUser>>
>;
export type CreateUserMutationBody = UserCreateDTO;
export type CreateUserMutationError =
  | ApiErrorDTO
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Creates a new user
 */
export const useCreateUser = <
  TError =
    | ApiErrorDTO
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUser>>,
    TError,
    { data: UserCreateDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  { data: UserCreateDTO },
  TContext
> => {
  const mutationOptions = getCreateUserMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Returns a `csv` file containing the complete list of users
 * @summary Returns a csv files containing all users
 */
export type downloadUsersResponse = {
  data: Blob;
  status: number;
};

export const getDownloadUsersUrl = () => {
  return `http://localhost:8080/platform/v1/users/download`;
};

export const downloadUsers = async (
  options?: RequestInit
): Promise<downloadUsersResponse> => {
  return customFetchInstance<Promise<downloadUsersResponse>>(
    getDownloadUsersUrl(),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getDownloadUsersQueryKey = () => {
  return [`http://localhost:8080/platform/v1/users/download`] as const;
};

export const getDownloadUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof downloadUsers>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadUsersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadUsers>>> = ({
    signal,
  }) => downloadUsers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadUsers>>
>;
export type DownloadUsersQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useDownloadUsers<
  TData = Awaited<ReturnType<typeof downloadUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof downloadUsers>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof downloadUsers>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof customFetchInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDownloadUsers<
  TData = Awaited<ReturnType<typeof downloadUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof downloadUsers>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof downloadUsers>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDownloadUsers<
  TData = Awaited<ReturnType<typeof downloadUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof downloadUsers>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a csv files containing all users
 */

export function useDownloadUsers<
  TData = Awaited<ReturnType<typeof downloadUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof downloadUsers>>, TError, TData>
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadUsersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDownloadUsersSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof downloadUsers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadUsersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadUsers>>> = ({
    signal,
  }) => downloadUsers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof downloadUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadUsersSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadUsers>>
>;
export type DownloadUsersSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useDownloadUsersSuspense<
  TData = Awaited<ReturnType<typeof downloadUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof downloadUsers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDownloadUsersSuspense<
  TData = Awaited<ReturnType<typeof downloadUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof downloadUsers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDownloadUsersSuspense<
  TData = Awaited<ReturnType<typeof downloadUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof downloadUsers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a csv files containing all users
 */

export function useDownloadUsersSuspense<
  TData = Awaited<ReturnType<typeof downloadUsers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof downloadUsers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadUsersSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns an Excel file with a list of users that consented to marketing
 * @summary Returns an Excel file with a list of users that consented to marketing
 */
export type getUsersMarketingConsentResponse = {
  data: Blob;
  status: number;
};

export const getGetUsersMarketingConsentUrl = () => {
  return `http://localhost:8080/platform/v1/users/marketing-consent`;
};

export const getUsersMarketingConsent = async (
  options?: RequestInit
): Promise<getUsersMarketingConsentResponse> => {
  return customFetchInstance<Promise<getUsersMarketingConsentResponse>>(
    getGetUsersMarketingConsentUrl(),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetUsersMarketingConsentQueryKey = () => {
  return [`http://localhost:8080/platform/v1/users/marketing-consent`] as const;
};

export const getGetUsersMarketingConsentQueryOptions = <
  TData = Awaited<ReturnType<typeof getUsersMarketingConsent>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUsersMarketingConsent>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUsersMarketingConsentQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUsersMarketingConsent>>
  > = ({ signal }) => getUsersMarketingConsent({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUsersMarketingConsent>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUsersMarketingConsentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUsersMarketingConsent>>
>;
export type GetUsersMarketingConsentQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetUsersMarketingConsent<
  TData = Awaited<ReturnType<typeof getUsersMarketingConsent>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUsersMarketingConsent>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUsersMarketingConsent>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof customFetchInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetUsersMarketingConsent<
  TData = Awaited<ReturnType<typeof getUsersMarketingConsent>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUsersMarketingConsent>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getUsersMarketingConsent>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetUsersMarketingConsent<
  TData = Awaited<ReturnType<typeof getUsersMarketingConsent>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUsersMarketingConsent>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns an Excel file with a list of users that consented to marketing
 */

export function useGetUsersMarketingConsent<
  TData = Awaited<ReturnType<typeof getUsersMarketingConsent>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUsersMarketingConsent>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUsersMarketingConsentQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetUsersMarketingConsentSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getUsersMarketingConsent>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getUsersMarketingConsent>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUsersMarketingConsentQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUsersMarketingConsent>>
  > = ({ signal }) => getUsersMarketingConsent({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getUsersMarketingConsent>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUsersMarketingConsentSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUsersMarketingConsent>>
>;
export type GetUsersMarketingConsentSuspenseQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetUsersMarketingConsentSuspense<
  TData = Awaited<ReturnType<typeof getUsersMarketingConsent>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getUsersMarketingConsent>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetUsersMarketingConsentSuspense<
  TData = Awaited<ReturnType<typeof getUsersMarketingConsent>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getUsersMarketingConsent>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetUsersMarketingConsentSuspense<
  TData = Awaited<ReturnType<typeof getUsersMarketingConsent>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getUsersMarketingConsent>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns an Excel file with a list of users that consented to marketing
 */

export function useGetUsersMarketingConsentSuspense<
  TData = Awaited<ReturnType<typeof getUsersMarketingConsent>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getUsersMarketingConsent>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUsersMarketingConsentSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a specific user by id
 * @summary Returns a specific user
 */
export type getUserByIdResponse = {
  data: UserDTO;
  status: number;
};

export const getGetUserByIdUrl = (userId: string) => {
  return `http://localhost:8080/platform/v1/users/${userId}`;
};

export const getUserById = async (
  userId: string,
  options?: RequestInit
): Promise<getUserByIdResponse> => {
  return customFetchInstance<Promise<getUserByIdResponse>>(
    getGetUserByIdUrl(userId),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetUserByIdQueryKey = (userId: string) => {
  return [`http://localhost:8080/platform/v1/users/${userId}`] as const;
};

export const getGetUserByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserByIdQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserById>>> = ({
    signal,
  }) => getUserById(userId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserById>>
>;
export type GetUserByIdQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetUserById<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetUserById<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetUserById<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a specific user
 */

export function useGetUserById<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserByIdQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetUserByIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserByIdQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserById>>> = ({
    signal,
  }) => getUserById(userId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getUserById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUserByIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserById>>
>;
export type GetUserByIdSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetUserByIdSuspense<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetUserByIdSuspense<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetUserByIdSuspense<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a specific user
 */

export function useGetUserByIdSuspense<
  TData = Awaited<ReturnType<typeof getUserById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUserById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetUserByIdSuspenseQueryOptions(userId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates a User. Can throw the following error codes:

`ERR_USERS_INVALID_ORGANISATION_CODE`,`ERR_USERS_INVALID_ORGANISATION_NAME` and `ERR_USERS_NO_ORGANISATION_NAME`.

Further explanation about the error codes can be found in the projects README.

 * @summary Updates a user
 */
export type updateUserByIdResponse = {
  data: UserDTO;
  status: number;
};

export const getUpdateUserByIdUrl = (userId: string) => {
  return `http://localhost:8080/platform/v1/users/${userId}`;
};

export const updateUserById = async (
  userId: string,
  userUpdateDTO: UserUpdateDTO,
  options?: RequestInit
): Promise<updateUserByIdResponse> => {
  return customFetchInstance<Promise<updateUserByIdResponse>>(
    getUpdateUserByIdUrl(userId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(userUpdateDTO),
    }
  );
};

export const getUpdateUserByIdMutationOptions = <
  TError =
    | ApiErrorDTO
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserById>>,
    TError,
    { userId: string; data: UserUpdateDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserById>>,
  TError,
  { userId: string; data: UserUpdateDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserById>>,
    { userId: string; data: UserUpdateDTO }
  > = (props) => {
    const { userId, data } = props ?? {};

    return updateUserById(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserById>>
>;
export type UpdateUserByIdMutationBody = UserUpdateDTO;
export type UpdateUserByIdMutationError =
  | ApiErrorDTO
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Updates a user
 */
export const useUpdateUserById = <
  TError =
    | ApiErrorDTO
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserById>>,
    TError,
    { userId: string; data: UserUpdateDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUserById>>,
  TError,
  { userId: string; data: UserUpdateDTO },
  TContext
> => {
  const mutationOptions = getUpdateUserByIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Deletes a specific user by id.
 * @summary Deletes a specific user.
 */
export type deleteUserByIdResponse = {
  data: DeleteSuccessDTO;
  status: number;
};

export const getDeleteUserByIdUrl = (userId: string) => {
  return `http://localhost:8080/platform/v1/users/${userId}`;
};

export const deleteUserById = async (
  userId: string,
  options?: RequestInit
): Promise<deleteUserByIdResponse> => {
  return customFetchInstance<Promise<deleteUserByIdResponse>>(
    getDeleteUserByIdUrl(userId),
    {
      ...options,
      method: "DELETE",
    }
  );
};

export const getDeleteUserByIdMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserById>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUserById>>,
  TError,
  { userId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUserById>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return deleteUserById(userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUserById>>
>;

export type DeleteUserByIdMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Deletes a specific user.
 */
export const useDeleteUserById = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserById>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteUserById>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getDeleteUserByIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Swaps the ownership of the organisation to the user identified by the path parameter `userId`.

 * @summary Updates ownership of a user
 */
export type transferOwnershipByIdResponse = {
  data: UserTransferSuccessDTO;
  status: number;
};

export const getTransferOwnershipByIdUrl = (userId: string) => {
  return `http://localhost:8080/platform/v1/users/${userId}/transfer-organisation-ownership`;
};

export const transferOwnershipById = async (
  userId: string,
  options?: RequestInit
): Promise<transferOwnershipByIdResponse> => {
  return customFetchInstance<Promise<transferOwnershipByIdResponse>>(
    getTransferOwnershipByIdUrl(userId),
    {
      ...options,
      method: "PUT",
    }
  );
};

export const getTransferOwnershipByIdMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferOwnershipById>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transferOwnershipById>>,
  TError,
  { userId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transferOwnershipById>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return transferOwnershipById(userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransferOwnershipByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof transferOwnershipById>>
>;

export type TransferOwnershipByIdMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Updates ownership of a user
 */
export const useTransferOwnershipById = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferOwnershipById>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof transferOwnershipById>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getTransferOwnershipByIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Sends an email for the required actions the user needs to take
 * @summary Sends an email for the required actions the user needs to take
 */
export type sendEmailForRequiredActionsResponse = {
  data: EmailSuccessDTO;
  status: number;
};

export const getSendEmailForRequiredActionsUrl = (userId: string) => {
  return `http://localhost:8080/platform/v1/users/${userId}/actions/trigger-action-email`;
};

export const sendEmailForRequiredActions = async (
  userId: string,
  options?: RequestInit
): Promise<sendEmailForRequiredActionsResponse> => {
  return customFetchInstance<Promise<sendEmailForRequiredActionsResponse>>(
    getSendEmailForRequiredActionsUrl(userId),
    {
      ...options,
      method: "POST",
    }
  );
};

export const getSendEmailForRequiredActionsMutationOptions = <
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendEmailForRequiredActions>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendEmailForRequiredActions>>,
  TError,
  { userId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendEmailForRequiredActions>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return sendEmailForRequiredActions(userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendEmailForRequiredActionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendEmailForRequiredActions>>
>;

export type SendEmailForRequiredActionsMutationError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Sends an email for the required actions the user needs to take
 */
export const useSendEmailForRequiredActions = <
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendEmailForRequiredActions>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendEmailForRequiredActions>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions =
    getSendEmailForRequiredActionsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Returns a set of statistics about the users.
 * @summary Returns a set of statistics about the users
 */
export type getStatisticsResponse = {
  data: GetStatistics200;
  status: number;
};

export const getGetStatisticsUrl = (
  userId: string,
  timeRange: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL" = "ALL"
) => {
  return `http://localhost:8080/platform/v1/users/${userId}/statistics/${timeRange}`;
};

export const getStatistics = async (
  userId: string,
  timeRange: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL" = "ALL",
  options?: RequestInit
): Promise<getStatisticsResponse> => {
  return customFetchInstance<Promise<getStatisticsResponse>>(
    getGetStatisticsUrl(userId, timeRange),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetStatisticsQueryKey = (
  userId: string,
  timeRange: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL" = "ALL"
) => {
  return [
    `http://localhost:8080/platform/v1/users/${userId}/statistics/${timeRange}`,
  ] as const;
};

export const getGetStatisticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  timeRange: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL" = "ALL",
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStatisticsQueryKey(userId, timeRange);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatistics>>> = ({
    signal,
  }) => getStatistics(userId, timeRange, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && timeRange),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStatistics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStatisticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStatistics>>
>;
export type GetStatisticsQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetStatistics<
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  timeRange: undefined | "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL",
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetStatistics<
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  timeRange?: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL",
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatistics>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetStatistics<
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  timeRange?: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL",
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a set of statistics about the users
 */

export function useGetStatistics<
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  timeRange: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL" = "ALL",
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStatistics>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStatisticsQueryOptions(userId, timeRange, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetStatisticsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  timeRange: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL" = "ALL",
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStatistics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStatisticsQueryKey(userId, timeRange);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatistics>>> = ({
    signal,
  }) => getStatistics(userId, timeRange, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && timeRange),
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getStatistics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStatisticsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStatistics>>
>;
export type GetStatisticsSuspenseQueryError =
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetStatisticsSuspense<
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  timeRange: undefined | "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL",
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStatistics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetStatisticsSuspense<
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  timeRange?: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL",
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStatistics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetStatisticsSuspense<
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  timeRange?: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL",
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStatistics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a set of statistics about the users
 */

export function useGetStatisticsSuspense<
  TData = Awaited<ReturnType<typeof getStatistics>>,
  TError =
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  timeRange: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL" = "ALL",
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getStatistics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStatisticsSuspenseQueryOptions(
    userId,
    timeRange,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a paginated list of catalog downloads for the supplier identified by userId. Each row represents one download event with ERP supplier, catalog, version and timestamp.

 * @summary Returns catalog download history for a supplier user
 */
export type getCatalogDownloadHistoryResponse = {
  data: PaginatedCatalogDownloadHistoryItemsDTO;
  status: number;
};

export const getGetCatalogDownloadHistoryUrl = (
  userId: string,
  params?: GetCatalogDownloadHistoryParams,
  timeRange: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL" = "ALL"
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `http://localhost:8080/platform/v1/users/${userId}/statistics/catalog-downloads/${timeRange}?${normalizedParams.toString()}`
    : `http://localhost:8080/platform/v1/users/${userId}/statistics/catalog-downloads/${timeRange}`;
};

export const getCatalogDownloadHistory = async (
  userId: string,
  params?: GetCatalogDownloadHistoryParams,
  timeRange: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL" = "ALL",
  options?: RequestInit
): Promise<getCatalogDownloadHistoryResponse> => {
  return customFetchInstance<Promise<getCatalogDownloadHistoryResponse>>(
    getGetCatalogDownloadHistoryUrl(userId, params, timeRange),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetCatalogDownloadHistoryQueryKey = (
  userId: string,
  params?: GetCatalogDownloadHistoryParams,
  timeRange: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL" = "ALL"
) => {
  return [
    `http://localhost:8080/platform/v1/users/${userId}/statistics/catalog-downloads/${timeRange}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCatalogDownloadHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  params?: GetCatalogDownloadHistoryParams,
  timeRange: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL" = "ALL",
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCatalogDownloadHistoryQueryKey(userId, params, timeRange);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCatalogDownloadHistory>>
  > = ({ signal }) =>
    getCatalogDownloadHistory(userId, params, timeRange, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && timeRange),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCatalogDownloadHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCatalogDownloadHistory>>
>;
export type GetCatalogDownloadHistoryQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetCatalogDownloadHistory<
  TData = Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  params: undefined | GetCatalogDownloadHistoryParams,
  timeRange: undefined | "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL",
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetCatalogDownloadHistory<
  TData = Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  params?: GetCatalogDownloadHistoryParams,
  timeRange?: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL",
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetCatalogDownloadHistory<
  TData = Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  params?: GetCatalogDownloadHistoryParams,
  timeRange?: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL",
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns catalog download history for a supplier user
 */

export function useGetCatalogDownloadHistory<
  TData = Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  params?: GetCatalogDownloadHistoryParams,
  timeRange: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL" = "ALL",
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCatalogDownloadHistoryQueryOptions(
    userId,
    params,
    timeRange,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCatalogDownloadHistorySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  params?: GetCatalogDownloadHistoryParams,
  timeRange: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL" = "ALL",
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCatalogDownloadHistoryQueryKey(userId, params, timeRange);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCatalogDownloadHistory>>
  > = ({ signal }) =>
    getCatalogDownloadHistory(userId, params, timeRange, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && timeRange),
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCatalogDownloadHistorySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCatalogDownloadHistory>>
>;
export type GetCatalogDownloadHistorySuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetCatalogDownloadHistorySuspense<
  TData = Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  params: undefined | GetCatalogDownloadHistoryParams,
  timeRange: undefined | "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL",
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetCatalogDownloadHistorySuspense<
  TData = Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  params?: GetCatalogDownloadHistoryParams,
  timeRange?: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL",
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetCatalogDownloadHistorySuspense<
  TData = Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  params?: GetCatalogDownloadHistoryParams,
  timeRange?: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL",
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns catalog download history for a supplier user
 */

export function useGetCatalogDownloadHistorySuspense<
  TData = Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  userId: string,
  params?: GetCatalogDownloadHistoryParams,
  timeRange: "WEEK" | "MONTH" | "HALF_YEAR" | "YEAR" | "ALL" = "ALL",
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCatalogDownloadHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCatalogDownloadHistorySuspenseQueryOptions(
    userId,
    params,
    timeRange,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
